import { QRCodeDecoderErrorCorrectionLevel, QRCodeEncoder } from '@zxing/library';

/**
 * A fixed QR code for the editor canvas, so colours and size can be judged on a
 * real code. The voucher's own code (its verification link) is only known when a
 * voucher is issued; the server draws that one the same way (modules as one path,
 * a 4-module quiet zone only when the element asks for one).
 */
export interface StaticQr {
  size: number; // modules including the quiet zone
  path: string; // SVG path of the dark modules, one unit per module
}

function build(content: string, quietZone: number): StaticQr {
  const matrix = QRCodeEncoder.encode(content, QRCodeDecoderErrorCorrectionLevel.L).getMatrix();
  const width = matrix.getWidth();
  let path = '';
  for (let y = 0; y < width; y++) {
    for (let x = 0; x < width; x++) {
      if (matrix.get(x, y) === 1) path += `M${x + quietZone},${y + quietZone}h1v1h-1z`;
    }
  }
  return { size: width + 2 * quietZone, path };
}

/** The editor's sample code: as long as a real verification link. */
const SAMPLE = 'https://app.schenkwerk.com/verify/beispiel-gutschein-1234';
export const STATIC_QR: StaticQr = build(SAMPLE, 0);
export const STATIC_QR_WITH_QUIET_ZONE: StaticQr = build(SAMPLE, 4);
